import React, { useEffect, useState, useRef } from 'react';
import AdminAssets from './AdminAssets';
import AdminSidebar from './AdminSidebar';
import axios from '../../utils/axiosInstance';
import { useNavigate } from 'react-router-dom'

const AdminUsers = () => {
  const [admins, setAdmins] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isPermissionsDropdownOpen, setIsPermissionsDropdownOpen] = useState(false);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true); 

  const [editMode, setEditMode] = useState(false);
  const [editingAdminId, setEditingAdminId] = useState(null);

  const branches = [
    'Head Office',
    'Pimpri Office',
    'Bengaluru Office',
  ];

  const permissionsList = [
    'Enquiries',
    'Demo Batch Enquiries',
    'Batch Schedule',
    'Free Placement Calls',
    'Recruiters Enquiries',
    'Success Stories',
    'Blogs',
    'Users',
  ];

  const branchDropdownRef = useRef(null);
  const permissionsDropdownRef = useRef(null);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    branch: [],
    permissions: [],
  });

  const [editFormData, setEditFormData] = useState({
    name: '',
    email: '',
    password: '',
    branch: [],
    permissions: [],
  });

  useEffect(() => {
    axios
          .get(`${process.env.REACT_APP_API_BASE}/admin/session`)
          .then((res) => {
            if (!res.data.loggedIn) {
              navigate('/admin');
            } else {
              setLoading(false);
              fetchAdmins();
            }
          })
          .catch(() => {
            navigate('/admin');
          });

    // setLoading(false);
    // fetchAdmins();

    const handleClickOutside = (event) => {
      if (
        branchDropdownRef.current &&
        !branchDropdownRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
      if (
        permissionsDropdownRef.current &&
        !permissionsDropdownRef.current.contains(event.target)
      ) {
        setIsPermissionsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [navigate]);


  const fetchAdmins = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE}/admin`);
      setAdmins(response.data);
    } catch (error) {
      console.error('Error fetching admins:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this admin?')) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_BASE}/admin/${id}`);
        setAdmins((prev) => prev.filter((e) => e._id !== id));
        window.location.reload();
      } catch (error) {
        console.error('Failed to delete admin:', error);
      }
    }
  };

  const handleChange = (e, isEdit = false) => {
  const { name, value } = e.target;

  if (isEdit) {
    setEditFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  } else {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
};


  const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    if (editMode && editingAdminId) {
      const response = await axios.put(`/admin/${editingAdminId}`, formData);
      if (response.status === 200) {
        alert('User updated successfully!');
      } else {
        alert('Failed to update user');
      }
    } else {
      const response = await axios.post('/admin/createuser', formData);
      if (response.status === 200) {
        alert('User Created Successfully!');
      } else {
        alert('Failed to create user');
      }
    }

    setFormData({ name: '', email: '', password: '', branch: [], permissions: [] });
    setEditMode(false);
    setEditingAdminId(null);
    window.$('#myModal').modal('hide');
    fetchAdmins(); // refresh the list
  } catch (err) {
    console.error(err);
    alert(err?.response?.data?.error || 'Error submitting user');
  }
};



  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const togglePermissionsDropdown = () => {
    setIsPermissionsDropdownOpen(!isPermissionsDropdownOpen);
  };

  const handleCheckboxChange = (e, isEdit = false) => {
  const { value, checked } = e.target;

  const updateBranch = (prevState) => {
    const updated = checked
      ? [...prevState.branch, value]
      : prevState.branch.filter((b) => b !== value);
    return { ...prevState, branch: updated };
  };

  if (isEdit) {
    setEditFormData((prev) => updateBranch(prev));
  } else {
    setFormData((prev) => updateBranch(prev));
  }
};


  const handlePermissionsChange = (e, isEdit = false) => {
  const { value, checked } = e.target;

  const updatePermissions = (prevState) => {
    const updated = checked
      ? [...prevState.permissions, value]
      : prevState.permissions.filter((p) => p !== value);
    return { ...prevState, permissions: updated };
  };

  if (isEdit) {
    setEditFormData((prev) => updatePermissions(prev));
  } else {
    setFormData((prev) => updatePermissions(prev));
  }
};




  if (loading) return null;

  return (
    <div>
      <AdminAssets />
      <AdminSidebar />

      <section className="content">
        <div className="container-fluid">
          <button
            type="button"
            className="btn btn-primary"
            data-toggle="modal"
            data-target="#myModal"
          >
            Add User
          </button>
          <br />
          <br />

          {/* Modal */}
          <div id="myModal" className="modal fade" role="dialog">
            <div className="modal-dialog">
              <div className="modal-content">
                <form onSubmit={handleSubmit}>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label htmlFor="name" className="form-label">
                        Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={(e) => handleChange(e)}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label">
                        Email
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={(e) => handleChange(e)}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="password" className="form-label">
                        Password
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="password"
                        name="password"
                        value={formData.password}
                        onChange={(e) => handleChange(e)}
                      />
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <div className="mb-3 position-relative" ref={branchDropdownRef}>
                          <label className="form-label">Branch</label>
                          <div
                            className="form-control"
                            onClick={toggleDropdown}
                            style={{ cursor: 'pointer' }}
                          >
                            {formData.branch.length > 0 ? formData.branch.join(', ') : 'Select Branch'}
                          </div>

                          {isDropdownOpen && (
                            <div
                              className="border p-2 position-absolute bg-white w-100"
                              style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}
                            >
                              {branches.map((branch) => (
                                <div className="form-check" key={branch}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={branch}
                                    name="branch"
                                    value={branch}
                                    checked={formData.branch.includes(branch)}
                                    onChange={(e) => handleCheckboxChange(e)}
                                  />
                                  <label className="form-check-label text-black" htmlFor={branch}>
                                    {branch}
                                  </label>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="mb-3 position-relative" ref={permissionsDropdownRef}>
                          <label className="form-label">Permissions</label>
                          <div
                            className="form-control"
                            onClick={togglePermissionsDropdown}
                            style={{ cursor: 'pointer' }}
                          >
                            {formData.permissions.length > 0
                              ? formData.permissions.join(', ')
                              : 'Select Permissions'}
                          </div>

                          {isPermissionsDropdownOpen && (
                            <div
                              className="border p-2 position-absolute bg-white w-100"
                              style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}
                            >
                              {permissionsList.map((perm) => (
                                <div className="form-check" key={perm}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={perm}
                                    value={perm}
                                    checked={formData.permissions.includes(perm)}
                                    onChange={handlePermissionsChange}
                                  />
                                  <label className="form-check-label text-black" htmlFor={perm}>
                                    {perm}
                                  </label>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div><br/><br/><br/><br/>
                  </div>

                  <div className="modal-footer">
                    <button type="submit" className="btn btn-success">
                      Save
                    </button>
                    <button type="button" className="btn btn-danger" data-dismiss="modal">
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>


          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="card">
                <div className="header">
                  <h2 className="fw-bold text-start">Users</h2>
                </div>
                <div className="body">
                  {admins.length === 0 ? (
                    <p>No admin found.</p>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped table-hover">
                        <thead>
                          <tr>
                            <th>Action</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Branch</th>
                            <th>Permissions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {admins.map((admins, index) => (
                            <tr key={admins._id}>
                              <td>
                                    <button
                                      className="btn btn-danger btn-sm"
                                      onClick={() => handleDelete(admins._id)}
                                    >
                                      Delete
                                    </button>
                              </td>
                              <td>{admins.name}</td>
                              <td>{admins.email}</td>
                              <td>
                                {Array.isArray(admins.branch)
                                  ? admins.branch.join(', ')
                                  : admins.branch}
                              </td>
                              <td>
                                {Array.isArray(admins.permissions)
                                  ? admins.permissions.join(', ')
                                  : admins.permissions}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th>Action</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Branch</th>
                            <th>Permissions</th>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdminUsers;
